import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bp-twoone-twotwo',
  templateUrl: './bp-twoone-twotwo.component.html',
  styleUrls: ['./bp-twoone-twotwo.component.scss']
})
export class BpTwooneTwotwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
